import React, { useRef, useEffect } from 'react';
import { tokens } from '../../styles/tokens';
import { useTheme } from '../../context/ThemeContext';
import { localizeItem } from '../../hooks/useLanguage';

export function CategoryTabs({ categories, activeId, onSelect, lang = 'ru', menuLabel = 'меню' }) {
  const scrollRef = useRef(null);
  const theme = useTheme();
  const { colors, isDark } = theme;

  useEffect(() => {
    if (!scrollRef.current || !activeId) return;
    const el = scrollRef.current.querySelector(`[data-cat-id="${activeId}"]`);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [activeId]);

  return (
    <div
      ref={scrollRef}
      style={{
        display: 'flex',
        gap: '8px',
        overflowX: 'auto',
        padding: '10px 16px 14px',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        backgroundColor: colors.bg,
        borderBottom: `1px solid ${colors.border}`,
        transition: 'background-color 0.3s',
      }}
    >
      <button
        onClick={() => {
          onSelect(null);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
        style={{
          flexShrink: 0,
          padding: '7px 16px',
          borderRadius: '100px',
          border: 'none',
          backgroundColor: activeId === null
            ? (isDark ? '#fff' : '#1A1A1A')
            : colors.bgChip,
          color: activeId === null
            ? (isDark ? '#000' : '#fff')
            : colors.textSecondary,
          fontSize: '13px',
          fontWeight: activeId === null ? '700' : '500',
          whiteSpace: 'nowrap',
          cursor: 'pointer',
          fontFamily: tokens.font.family,
          transition: 'all 0.15s ease',
        }}
      >
        {menuLabel}
      </button>

      {categories.map((cat) => {
        const isActive = cat.id === activeId;
        return (
          <button
            key={cat.id}
            data-cat-id={cat.id}
            onClick={() => onSelect(cat.id)}
            style={{
              flexShrink: 0,
              padding: '7px 16px',
              borderRadius: '100px',
              border: 'none',
              backgroundColor: isActive
                ? (isDark ? '#fff' : '#1A1A1A')
                : colors.bgChip,
              color: isActive
                ? (isDark ? '#000' : '#fff')
                : colors.textSecondary,
              fontSize: '13px',
              fontWeight: isActive ? '700' : '400',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              fontFamily: tokens.font.family,
              transition: 'all 0.15s ease',
            }}
          >
            {localizeItem(cat, lang)}
          </button>
        );
      })}
    </div>
  );
}
